export default "__VITE_ASSET__C3DOblN6__"